import { Injectable } from '@angular/core';
import { globalWindow } from 'src/shared/window-globals';

@Injectable()
export class FooterService {
  getServerNumber(): Promise<{ serverNumber: string }> {
    return fetch(globalWindow.UrlResolver.PortalAPI('server-number'))
      .then(response => response.json());
  }
}
